import { ContentFormality } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { IUserSessionComponentProps } from '../../../../models/AppState';
import { RadioButton } from '../../RadioButton';
import { styleSheet } from './styles';

interface IProps extends IUserSessionComponentProps {
	className?: string;
	formality?: ContentFormality;
	setFormality?(formality: ContentFormality): void;
	styles?: StyleDeclarationValue[];
}

export const ContentFormalitySelect: React.FC<IProps> = props => {
	const { className, formality, setFormality, styles } = props;

	const onChange = (newFormality: ContentFormality) => () => {
		setFormality(newFormality);
	};

	return (
		<div className={`${css(styleSheet.container, ...(styles || []))} content-formality-select ${className || ''}`}>
			<RadioButton
				checked={formality === ContentFormality.Formal}
				id={uuid()}
				name='content-formality-select-formal'
				onChange={onChange(ContentFormality.Formal)}
			>
				<div>Formal</div>
			</RadioButton>
			<RadioButton
				checked={formality === ContentFormality.Lighthearted}
				id={uuid()}
				name='content-formality-select-lighthearted'
				onChange={onChange(ContentFormality.Lighthearted)}
			>
				<div>Lighthearted</div>
			</RadioButton>
			<RadioButton
				checked={formality === ContentFormality.ToneMix}
				id={uuid()}
				name='content-formality-select-tonemix'
				onChange={onChange(ContentFormality.ToneMix)}
			>
				<div>A mix of both</div>
			</RadioButton>
		</div>
	);
};
